import { en, locales } from '@stripe-internal/cldr';
export const DEFAULT_LOCALE = 'en-US';
export const DEBUG_LOCALES = Object.freeze([
    'en-US-x-MESSAGE-ID',
    'en-US-x-STAR',
    'en-US-x-WIDE'
]);
export const SUPPORTED_LOCALES = Object.freeze([
    ...locales,
    ...DEBUG_LOCALES
]);
export const DEFAULT_LOCALE_DATA = {
    locale: DEFAULT_LOCALE,
    messages: {},
    cldr: en.cldr,
    dateTimeStyles: en.dateTimeStyles
};
export const DEFAULT_TIME_ZONE = (()=>{
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (error) {
        return 'Etc/UTC';
    }
})();

//# sourceMappingURL=constants.js.map